import React, { useEffect, useRef, useState } from 'react';
import FilterComponents from '../../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import pencilIcon from './../../../../assets/icons/editPencil.png'
import filterIcon from './../../../../assets/icons/filter 1.png'
import bin from './../../../../assets/icons/recycle-binColor.png'
import VATEditDialog from '../VATEditDialog/VATEditDialog.tsx';
import { Box, Button, Grid, Modal, Typography, Paper } from '@mui/material'
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import { toast } from 'react-toastify';
import VATSetupDialog from '../VATSetupDialog/VATSetupDialog.tsx';
import AddTableDialog from '../AddTableDialog/AddTableDialog.tsx';
import EditTableDialog from '../EditTableDialog/EditTableDialog.tsx';
import html2pdf from "html2pdf.js";
import "./TableSetupPage.css";
import scanner from "../../../../assets/icons/scanner.png";
import QrPdfComponent from '../../../QrCode/QrPdfComponent.tsx';
import close from "../../../../assets/icons/close.png";
import downloads from "../../../../assets/icons/downloads.png";
import qrCode from "../../../../assets/icons/qr-code-icon.png";
import { convertImageToBase64 } from '../../../../utils/convertToBase64.js';
import jwt_decode from "jwt-decode";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Swiper, SwiperSlide } from "swiper/react";

import RightArrow from "../../../../assets/icons/right-arrow.png";
import LeftArrow from "../../../../assets/icons/left-arrow.png";


function TableSetupPage(props) {
    const [showQrModal, setShowQrModal] = useState(false);
    const [QrData, setQrData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const downloadPdfRef = useRef(null);

    const handleDownloadPdf = () => {
        const element = downloadPdfRef.current;
        const opt = {
            margin: 1,
            filename: "QrCode.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },  // Enable CORS for external images
            jsPDF: { unit: "mm", format: "letter", orientation: "portrait" },
        };

        // Use html2pdf to generate and download the PDF
        html2pdf().from(element).set(opt).save();
    };

    const [restaurantDataRows, setRestaurantDataRows] = useState([])

    const loadRestaurantData = async () => {
        const token = localStorage.getItem("gotasteadmintoken");
        var decodedData = {};
        if (token != null) {
            try {
                decodedData = jwt_decode(token);

                var obj = {
                    id: decodedData.UserId,
                    title: decodedData.UserName,
                };
            } catch (error) { }
        }
        const restaurant = JSON.parse(localStorage.getItem("restaurant"));
        axios
            .get(
                apiAddress +
                "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
                decodedData.UserId +
                "/" +
                restaurant.id
            )
            .then((response) => {
                console.log(response.data);
                var list = [];
                // list.push(response.data)
                // setRestaurantDatas(list);
                response.data.map((dt, i) => {
                    var obj = {
                        id: dt.id,
                        name: dt.name,
                        address: dt.addressLine1,
                        PhoneNumber: dt.phoneNumber,
                        Email: dt.emailAddress,
                        isActive: dt.isActive
                    };
                    list.push(obj);
                });

                setRestaurantDataRows(list);
                loadData(response.data[0])
                setselectedRes(response.data[0])
            });
    };

    console.log("restaurant data", restaurantDataRows)
    const handleGenerateQrCode = async (row) => {
        setShowQrModal(true);
        try {
            setError("");
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_SECRET}/api/RestaurantTable/GetSelectedTableByTableIdAndRestaurantId?tableId=${row.id}&restaurantId=${row.restaurantId}`);

            setQrData(response?.data);
            setLoading(false);
        } catch (error) {
            setError(error.response.data);
            setLoading(false);
            console.log(error);
        }
    }

    console.log('Page Initilized')
    const columns = [
        {
            field: 'name', headerName: 'Table Name', align: 'center',
            renderCell: (params) =>
                <div className='d-flex align-items-center justify-content-center' style={{ gap: "5px", cursor: "pointer" }} onClick={() => { selectDataForEdit(params.value); setOpen(true) }} >
                    <span style={{ color: "blue", cursor: "pointer" }}>{params.value} </span>
                    <img src={pencilIcon} alt="" style={{ width: ".8rem" }} />
                </div>,
            headerAlign: 'center', flex: 1
        },


        { field: 'Seats', headerName: 'Total Seats', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'floorNumber', headerName: 'Floor Number', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'seatPosition', headerName: 'Seat Location', align: 'center', headerAlign: 'center', flex: 1 },

        {
            headerName: "Action", align: "center", headerAlign: "center",
            renderCell: (params) =>
                <div
                    className='d-flex align-items-center justify-content-center printer-icon'
                    style={{ gap: "5px", cursor: "pointer" }}
                    onClick={() => handleGenerateQrCode(params.row)}
                    title="Generate QR code"
                >
                    <img src={qrCode} alt="qr code icon" />
                </div>
        }
    ];

    const [dataRows, setDataRows] = useState([])
    const [open, setOpen] = React.useState(false)
    const [selectedDatas, setselectedDatas] = useState()

    const selectDataForEdit = (props) => {
        console.log(props);
        console.log(dataRows);
        var obj = dataRows.find(x => x.name == props);
        console.log(obj)
        setselectedDatas(obj.id)
    }

    const handleAddItem = (AddSectionData) => {
        setOpenAddSection(AddSectionData)
        loadData(selectedRes);
        console.log(AddSectionData)
    }
    const handleUpdateItem = (AddItemData) => {
        setOpen(AddItemData);
        loadData(selectedRes);
    }

    const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
    const [selectedDataRows, setSelectedDatarows] = React.useState([]);
    const [openAddSection, setOpenAddSection] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const [selectedData, setSelectedData] = useState({})

    const handleClickOpen = () => {
        setOpenAddSection(true);
        setDialogType('Add Table');
    }

    const handleAddMenuDialogData = (data) => {
        setSelectedData(data);
        //loadData();
    }

    // const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     if (props.isItem != 6) {
    //       setOpen(true)
    //     }
    //     else {
    //       setAnchorEl(event.currentTarget);
    //     }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openDropdown = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getselectedData = (props) => {
        console.log(props)
        setSelectedDatarows(props)
    }

    const deleteBin = () => {

        var url = apiAddress + "/api/RestaurantTable/DeleteRestaurantTableInfoByTableId"
        axios
            .put(url, selectedDataRows)
            .then((response) => {
                toast.success("successfully deleted", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

                setopenConfirmaitonModal(false)
                //loadData();
            })

        //loadData()

    }
    const errorToast = (msg) => {
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const restaurant = JSON.parse(localStorage.getItem('restaurant'));

    const apiAddress = process.env.REACT_APP_SECRET;
    useEffect(() => {
        //loadData();
        loadRestaurantData()
        console.log("Table page called")
        console.log(restaurant)

    }, [])

    const loadData = (data) => {
        axios({
            method: 'get',
            url: apiAddress + '/api/RestaurantTable/GetAllRestaurantTableInfosByRestaurantId?restaurantId=' + data.id,
        })
            .then((response) => {
                console.log(response)
                var list = [];
                response.data.map((dt, i) => {
                    var obj = {
                        id: dt.tableId,
                        name: dt.tableName,
                        Seats: dt.totalChairUnderThisTable,
                        restaurantId: dt.restaurantId,
                        floorNumber: dt.floorNumber,
                        seatPosition: dt.seatPosition,
                    }
                    list.push(obj);
                })
                setDataRows(list);
            })
            .catch((error) => {

            });
    }
    const [value, setValue] = React.useState(0);

    const sliderRef = useRef(null);

    const handleNext = (swiperRef) => {
        swiperRef.current.swiper.slideNext();
    };

    const handlePrev = (swiperRef) => {
        swiperRef.current.swiper.slidePrev();
    };

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
        console.log(newValue);
    };

    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    const [selectedRes, setselectedRes] = useState();

    console.log("selectedRes",selectedRes)

    const onTabClick = (data) => {
        console.log("data",data)
        setselectedRes(data);
        // setDataRows([]);
        // loadFoodData(data);
        loadData(data)
        console.log("data",data);
    };

    const TabViewItem = ({ children, count, data }) => {
        console.log("count: " + count);
        console.log("value: " + value);

        return (
            <div
                onClick={() => {
                    onTabClick(data);
                }}
            >
                {<div>{children}</div>}
            </div>
        );
    };

    return (
        <div>
            <div>
                {restaurantDataRows.length > 0 ? (
                    <div className="tabview">
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <div className="slider-container">
                                    <button
                                        onClick={() => {
                                            handlePrev(sliderRef);
                                        }}
                                        className="arrow-btn-food"
                                    >
                                        <img src={LeftArrow} alt={"arrow"} />
                                    </button>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={"auto"}
                                        ref={sliderRef}
                                    >
                                        <TabList
                                            onChange={handleChange}
                                            aria-label="lab API tabs example"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                        >
                                            {restaurantDataRows.map((dt, i) => {
                                                return (
                                                    // <Tab label={dt.menuName} value={i} />
                                                    <SwiperSlide
                                                        key={i}
                                                        style={{ width: "auto" }}
                                                        className={i === activeTab ? "tab-active" : ""}
                                                    >
                                                        <Tab
                                                            className="p-0"
                                                            label={
                                                                <TabViewItem count={i} data={dt}>
                                                                    <div style={{ padding: '13px' }}>
                                                                        {dt.name}
                                                                    </div>
                                                                </TabViewItem>
                                                            }
                                                            value={i}
                                                            onClick={() => handleTabClick(i)}
                                                        />
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </TabList>
                                    </Swiper>
                                    <button
                                        onClick={() => {
                                            handleNext(sliderRef);
                                        }}
                                        className="arrow-btn-food"
                                    >
                                        <img src={RightArrow} alt="arrow" />
                                    </button>
                                </div>
                            </Box>

                            {restaurantDataRows.map((dt, i) => {
                                return value == i ? (
                                    <>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="space-between"
                                            mt={2}
                                            mb={2}
                                            style={{ width: '100%' }}
                                        >
                                            <SweetAlertModal
                                                headerText={"Are you sure?"}
                                                bodyText={"You want to delete this?"}
                                                open={openConfirmaitonModal} onyes={deleteBin}
                                                close={() => { setopenConfirmaitonModal(false) }}
                                            />
                                            <Grid item>
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item>
                                                        <Button
                                                            color="primary"
                                                            size="medium"
                                                            variant="contained"
                                                            style={{ borderRadius: '50%', minWidth: 'auto' }}
                                                            onClick={handleClickOpen}
                                                        >
                                                            +
                                                        </Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <div className='roundedCorner'>
                                                            <img src={bin}
                                                                alt=""
                                                                style={{ width: '1rem' }}
                                                                onClick={() => { selectedDataRows.length == 0 ? errorToast("Please select a row") : setopenConfirmaitonModal(true) }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* <Grid item>
                                                <Grid
                                                    container
                                                    flexDirection={"column"}
                                                    alignItems={"center"}
                                                >
                                                    <Grid item>
                                                        <img
                                                            src={searchIcon}
                                                            alt=""
                                                            style={{ width: "1rem" }}
                                                        />
                                                    </Grid>
                                                    <Grid item>Search</Grid>
                                                </Grid>
                                            </Grid> */}
                                        </Grid>

                                        <Paper>
                                            {dataRows.length > 0 ? (
                                                <CustomDataGrid
                                                    columns={columns}
                                                    dataRows={dataRows}
                                                    getselectedData={getselectedData}
                                                />
                                            ) : (
                                                "No Data Found"
                                            )}
                                        </Paper>
                                    </>
                                ) : (
                                    ""
                                );
                            })}
                        </TabContext>
                    </div>
                ) : (
                    <div className="mt-1">
                        {/* <button className="btn btnAddNew" onClick={handleClickAddMenuOpen}>
                            + Add new
                        </button> */}
                    </div>
                )}
                {/* <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    mt={2}
                    mb={2}
                >
                    <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to delete this?"} open={openConfirmaitonModal} onyes={deleteBin} close={() => { setopenConfirmaitonModal(false) }} />
                    <Grid item>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item>
                                <Button
                                    color="primary"
                                    size="medium"
                                    variant="contained"
                                    style={{ borderRadius: '50%', minWidth: 'auto' }}
                                    onClick={handleClickOpen}
                                >
                                    +
                                </Button>
                            </Grid>
                            <Grid item>
                                <div className='roundedCorner'>
                                    <img src={bin}
                                        alt=""
                                        style={{ width: '1rem' }}
                                        onClick={() => { selectedDataRows.length == 0 ? errorToast("Please select a row") : setopenConfirmaitonModal(true) }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid> */}
                {/* <FilterComponents title={"OK"} isItem={2} /> */}
                {/* <CustomDataGrid columns={columns} dataRows={dataRows} getselectedData={getselectedData} /> */}

                <AddTableDialog open={openAddSection}
                    dialogType={dialogType}
                    onHandleAddItem={handleAddItem}
                    onHandleSelectedData={handleAddMenuDialogData}
                    selectedRestaurant ={selectedRes}
                />
            </div>
            {
                open ? (
                    <EditTableDialog open={open}
                        onHandleAddItem={handleUpdateItem}
                        title={props.title}
                        isEdit={"true"}
                        selectedId={selectedDatas} />
                ) : ""
            }

            <Modal
                open={showQrModal}
                onClose={() => setShowQrModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal-wrapper">
                    <Typography className="header-wrapper" id="modal-modal-title" variant="h6" component="h2">
                        <div>QR code</div>
                        <div className="close-btn" onClick={() => setShowQrModal(false)}>
                            <img src={close} alt="close button" />
                        </div>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        {
                            loading
                                ?
                                <div>Generating Qr code...</div>
                                :
                                <QrPdfComponent
                                    scanner={scanner}
                                    data={QrData}
                                    componentRef={downloadPdfRef}
                                    isTableQr={true}
                                />
                        }
                    </Typography>
                    <div className="table-btn-group">
                        <button
                            className="table-setup-btn table-setup-close-btn"
                            onClick={() => setShowQrModal(false)}
                        >
                            Close
                        </button>

                        <button
                            className="table-setup-btn download-button"
                            onClick={handleDownloadPdf}
                        >
                            <span>Download as pdf</span>
                            <span className="download-icon">
                                <img src={downloads} alt="download icon" />
                            </span>
                        </button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}

export default TableSetupPage;